<template>
  <div class="container">
    <div class="alert alert-warning">
        {{$t("Laissez-vous guider afin de créer votre compte Géoportail.")}}
    </div>
    <div v-if="showSuccess" class="alert alert-success" role="alert">
      {{$t("Données correctement sauvées.")}}
    </div>
    <div v-if="showError" class="alert alert-danger" role="alert">
      {{errorMessage}}
    </div>
    <div v-if="loginExists === true" class="alert alert-danger" role="alert">
      {{$t("Le nom d'utilisateur {usernameError} est déjà utilisé. Veuillez en choisir un autre.")}}
    </div>
    <div v-if="passwordError === true" class="alert alert-danger" role="alert">
      {{$t("Les 2 mots de passe ne correspondent pas. Veuillez vérifier les données entrées.")}}
    </div>
    <div v-if="mailError === true" class="alert alert-danger" role="alert">
      {{$t("Les 2 adresses mail ne correspondent pas. Veuillez vérifier les données entrées.")}}
    </div>
    <div class="row" v-if="step=='step1'">
      <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
        <div class="card card-signin my-5">
          <div class="card-body">
            <h5 class="card-title text-center">{{$t("Première étape. Choississez un identifiant qui vous permettra de vous connecter.")}}</h5>
            <div class="form-label-group">
                <input type="text" id="username" name="username" v-model="username" class="form-control" v-bind:placeholder="$t('Utilisateur Geoportail')" required="true" autofocus=""  autocomplete="username">
                <label for="username">{{$t("Utilisateur Geoportail")}}</label>
            </div>
            <button class="btn btn-lg btn-primary btn-block text-uppercase" @click="goToStep2">{{$t("Etape suivante")}}</button>
            <p class="forgot-password text-right mt-2 mb-4">
                <router-link to="/">{{$t("Retour à l'écran de connexion")}}</router-link> |
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="step=='step3'">
      <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
        <div class="card card-signin my-5">
          <div class="card-body">
              <h5 class="card-title text-center">{{$t("Troisième étape. Choississez un mot de passe.")}}</h5>
              <div class="col-sm-10 col-md-12">
                <div class="form-row">
                  <div class="col-12 form-group">
                    <input type="password" class="form-control" v-bind:placeholder="$t('Mot de passe')" v-model="pwd1">
                  </div>
                  <div class="col-12 form-group">
                    <input type="password" class="form-control" v-bind:placeholder="$t('Confirmation du mot de passe')" v-model="pwd2">
                  </div>
                </div>
              </div>
              <button class="btn btn-lg btn-primary btn-block text-uppercase" @click="goToStep4">{{$t("Etape suivante")}}</button>
              <button class="btn btn-lg btn-primary btn-block text-uppercase" @click="goToStep2">{{$t("Etape précédente")}}</button>
              <p class="forgot-password text-right mt-2 mb-4">
                  <router-link to="/">{{$t("Retour à l'écran de connexion")}}</router-link> |
              </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="step=='step2'">
      <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
        <div class="card card-signin my-5">
          <div class="card-body">
              <h5 class="card-title text-center">{{$t("Deuxième étape. Entrez une adresse email valide.")}}</h5>
              <div class="col-sm-10 col-md-12">
                <div class="form-row">
                  <div class="col-12 form-group">
                    <input type="text" class="form-control" v-bind:placeholder="$t('Email')" v-model="mail1">
                  </div>
                  <div class="col-12 form-group">
                    <input type="text" class="form-control" v-bind:placeholder="$t('Confirmer Email')" v-model="mail2">
                  </div>
                </div>
              </div>
              <button class="btn btn-lg btn-primary btn-block text-uppercase" @click="goToStep3">{{$t("Etape suivante")}}</button>
              <button class="btn btn-lg btn-primary btn-block text-uppercase" @click="goToStep1">{{$t("Etape précédente")}}</button>
              <p class="forgot-password text-right mt-2 mb-4">
                  <router-link to="/">{{$t("Retour à l'écran de connexion")}}</router-link> |
              </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="step=='step4'">
      <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
        <div class="card card-signin my-5">
          <div class="card-body">
            <h5 class="card-title text-center">{{$t("Quatrième étape. Entrez vos informations personnelles.")}}</h5>
            <div class="col-sm-10 col-md12">
              <div class="form-row">
                <div class="col-12 form-group">
                  <input type="text" v-model="surename" class="form-control" v-bind:placeholder="$t('Nom et Prénom')">
                </div>
                <div class="col-12 form-group">
                  <input type="text" class="form-control" v-model="company" v-bind:placeholder="$t('Société')">
                </div>
                <div class="col-12 form-group">
                  <input type="text" class="form-control" v-bind:placeholder="$t('Adresse')" v-model="address1">
                </div>
                <div class="col-12 form-group">
                  <input type="text" class="form-control" v-bind:placeholder="$t('Adresse 2')" v-model="address2">
                </div>
                <div class="col-5 form-group">
                  <input type="text" class="form-control" v-bind:placeholder="$t('Code Postal')" v-model="postalCode">
                </div>
                <div class="col-7 form-group">
                  <input type="text" class="form-control" v-bind:placeholder="$t('Ville')" v-model="locality">
                </div>
                <div class="col-12 form-group">
                  <input type="text" class="form-control" v-bind:placeholder="$t('Pays')" v-model="state">
                </div>
                <div class="col-12 form-group">
                  <input type="text" class="form-control" v-bind:placeholder="$t('Phone')" v-model="phone">
                </div>
              </div>
            </div>
              <button class="btn btn-lg btn-primary btn-block text-uppercase" :disabled="isDisabled" @click="createUser" id="buttonCreateUser">{{$t("Créer votre utilisateur")}}</button>
              <button class="btn btn-lg btn-primary btn-block text-uppercase" @click="goToStep3" >{{$t("Etape précédente")}}</button>
              <p class="forgot-password text-right mt-2 mb-4">
                  <router-link to="/">{{$t("Retour à l'écran de connexion")}}</router-link> |
              </p>
          </div>
        </div>
      </div>
    </div>
  <div class="row" v-if="step=='step5'">
      <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
        <div class="card card-signin my-5">
          <div class="card-body">
            <h5 class="card-title text-center">{{$t("Félicitations! Votre utilisateur a été correctement créé. Vous pouvez retourner à l'écran d'accueil pour vous connecter")}}</h5>
              <p class="forgot-password text-right mt-2 mb-4">
                  <router-link to="/">{{$t("Retour à l'écran de connexion")}}</router-link> |
              </p>
          </div>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import { ref } from 'vue';
import i18n from '@/i18n';

export default {
    setup() {
      const $t = (key) => {
          if (!key) {
              return '';
          }
          return i18n.global.t(key);
      };

      const showSuccess = ref(false);
      const showError = ref(false);
      const loginExists = ref(false);
      const pwd1 = ref("");
      const pwd2 = ref("");
      const mail1 = ref("");
      const mail2 = ref("");
      const username = ref("");
      const usernameError = ref("");
      const step = ref("step1");
      const passwordError = ref(false);
      const mailError = ref(false);

      const surename = ref("");
      const company = ref("");
      const address1 = ref("");
      const address2 = ref("");
      const locality = ref("");
      const state = ref("LUXEMBOURG");
      const postalCode = ref("");
      const phone = ref("");
      const representants = ref("");
      const errorMessage = ref('');
      const isDisabled = ref(false);

      const goToStep1 = function() {
        step.value = "step1";
      }
      const goToStep3 = function() {
        if (mail1.value.length == 0) return 0;
        if (mail1.value === mail2.value) {
          step.value = "step3";
          mailError.value = false;
        } else {
          mailError.value = true;
        }
      }
      const goToStep4 = function() {
        if (pwd1.value.length == 0) return 0;
        if (pwd1.value == pwd2.value) {
          step.value = "step4";
          passwordError.value = false;
        } else {
          passwordError.value = true;
        }
      }
      const goToStep2 = function() {
        let formData = new FormData();
        if (username.value.length == 0) return 0;
        formData.append('username', username.value);
        formData.append('lang', i18n.global.locale.value);
        fetch("api/checklogin", {
                body: formData,
                method: "post"
            }).then(function(resp) {
                resp.json().then(function(status) {
                    if ('success' in status && status.success == false) {
                         step.value = "step2";
                         loginExists.value = false;
                         loginExists.value = false;
                    } else {
                        usernameError.value = username.value;
                        loginExists.value = true;
                    }
                });
            });
      }
      const validate = function() {
        if (!validatePhone(phone.value)) {
          showErrorMessage($t("Le numéro de téléphone n'est pas correctement rempli."));
          return false;
        }
        if (!validateEmail(mail1.value)) {
          showErrorMessage($t("L'email semble ne pas être correct"));
          return false;
        }
        if (mail1.value !== mail2.value) {
          showErrorMessage($t("Les emails ne sont pas identiques"));
          return false;
        }
        if (locality.value.length == 0) {
          showErrorMessage($t("Veuillez renseigner une localité"));
          return false;
        }
        if (state.value.length == 0) {
          showErrorMessage($t("Veuillez renseigner un pays"));
          return false;
        }
        if (postalCode.value.length == 0) {
          showErrorMessage($t("Veuillez renseigner un code postal"));
          return false;
        }
        if (address1.value.length == 0) {
          showErrorMessage($t("Veuillez renseigner une adresse"));
          return false;
        }
        if (surename.value.length == 0) {
          showErrorMessage($t("Veuillez renseigner un nom"));
          return false;
        }
        return true;
      }
      const showErrorMessage = function(pError) {
        errorMessage.value = pError;
        showError.value = true;
        setTimeout(function () {
          showError.value = false;
        }, 5000); 
      }
      const createUser = function() {
        if (!validate()) {
          return false;
        }
        isDisabled.value = true;
        let formData = new FormData();
        formData.append('lang', i18n.global.locale.value);
        formData.append('username', (username.value === undefined) ? '' : username.value);
        formData.append('sn', (surename.value === undefined) ? '' : surename.value);
        formData.append('contact', (company.value === undefined) ? '' : company.value);
        formData.append('representants', (representants.value === undefined) ? '' : representants.value);
        formData.append('cLigne1', (address1.value === undefined) ? '' : address1.value);
        formData.append('cLigne2', (address2.value === undefined) ? '' : address2.value);
        formData.append('l', (locality.value === undefined) ? '' : locality.value);
        formData.append('st', (state.value === undefined) ? '' : state.value);
        formData.append('postalCode', (postalCode.value === undefined) ? '' : postalCode.value);
        formData.append('mail', (mail1.value === undefined) ? '' : mail1.value);
        formData.append('telephoneNumber', (phone.value === undefined) ? '' : phone.value);
        formData.append('pwd', (pwd1.value === undefined) ? '' : pwd1.value);

        fetch("api/createuser", {
            body: formData,
            method: "post"
        }).then(function(resp) {
          resp.json().then(function(res) {
              if ('success' in res) {
                  if (res['success'] == true) {
                    showSuccess.value = true;
                    setTimeout(function () {
                      showSuccess.value = false;
                    }, 5000);
                    step.value = 'step5';
                  } else {
                    showErrorMessage($t("Une erreur est survenue lors de la sauvegarde de vos informations : ") + res['message']);
                  }
                  isDisabled.value = false;
              }  else {
                    showErrorMessage($t("Une erreur est survenue lors de la sauvegarde de vos informations : ") + res['message']);
                  }
              isDisabled.value = false; 
          }.bind(this));
        }).catch(function(error) {
          showErrorMessage($t("Une erreur est survenue lors de la sauvegarde de vos informations : ") + error);
        });
      }
      const cancel = function() {
        step.value = "step1";
      }
      const validateEmail = function (email) {
        if (email.trim().length == 0) {
        return true;
        }
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      }
      const validatePhone = function (phone) {
        var re = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\\./0-9]*$/;
        return re.test(phone);
      }
      return {
        loginExists,
        step,
        username,
        usernameError,
        goToStep2,
        cancel,
        pwd1,
        pwd2,
        goToStep3,
        goToStep4,
        passwordError,
        mailError,
        mail1,
        mail2,
        goToStep1,
        surename,
        company,
        address1,
        address2,
        locality,
        state,
        postalCode,
        phone,
        representants,
        createUser,
        errorMessage,
        showSuccess,
        showError,
        isDisabled,
      }
    }
}
</script>
